import { useContext } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Container, Nav, Navbar, NavDropdown} from 'react-bootstrap';
import { GlobalStateContext } from '../store/GlobalState';
//import api from '../app/api/agent';
//import Cookies from 'js-cookie';
const CustomNavBar = () => {

  
  const globalState = useContext(GlobalStateContext);

  return (
    <Navbar expand="lg" className="mb-5" >
      <Container className="container_particular_sm">
        <Navbar.Brand href="/form/list">Home</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav activeKey={window.location.pathname} className="me-auto">
            <Nav.Link href="/form/list">View Form</Nav.Link>
            <Nav.Link href="/form" target="_blank">Create New Form</Nav.Link>
          </Nav>
          <Nav activeKey={window.location.pathname}>
            <Nav.Link href="/userinfo">UserInfo</Nav.Link>
            {(localStorage.getItem("role") === "0") &&
            <Nav.Link href="/alert/list">Alert</Nav.Link>}
            {(localStorage.getItem("role") === "0") &&
            <Nav.Link href="/approve/list">Approval</Nav.Link>}
            {(localStorage.getItem("role") === "0") &&
            <Nav.Link href="/admin/list">Account</Nav.Link>}
            <Nav.Link onClick={()=>{     
                if(localStorage.accessToken){
                    localStorage.removeItem("accessToken")
                    localStorage.removeItem("refreshToken")
                    localStorage.removeItem("expireAt")
                    localStorage.removeItem("role")
                    globalState?.setAccessToken('');
                    window.location.href='/'
                }else{
                  //api.get("OIDC/logout?returnUrl=https://localhost:3001/",{withCredentials: true,})
                  window.location.href=process.env.REACT_APP_HR_PRO_SIGN_OUT_URL!;
                }
              }}>Logout</Nav.Link>
            {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
              <NavDropdown.Item href="/admin/list">Admin</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={()=>{
                var a = Cookies.get(".AspNetCore.CookiesC1")
                        
                if(a === undefined || a === "{}"){
                    localStorage.removeItem("accessToken")
                    localStorage.removeItem("refreshToken")
                    localStorage.removeItem("expireAt")
                    localStorage.removeItem("role")
                    globalState?.setAccessToken('');
                    window.location.href='/'
                }else{
                    window.location.href=process.env.REACT_APP_HR_PRO_SIGN_OUT_URL!;
                }
              }}>
                Logout
              </NavDropdown.Item>
            </NavDropdown> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavBar;
